import * as React from 'react'
import { PageProps } from 'gatsby'

import Layout from '../containers/layout'
import Header from '../components/header'
import Footer from '../components/footer'

const PrivacyPolicyPage: React.FC<PageProps> = ({
  location,
  pageContext,
}) => (
  <Layout
    id="content"
    subtitle="プライバシーポリシー"
    pageContext={pageContext}
  >
    <section id="top">
      <Header location={location} pageContext={pageContext} />
    </section>

    <div className="content-wrap">
      <section className="privacy">
        <article>
          <h2>プライバシーポリシー</h2>
          <p>
            株式会社EmbodyMe（以下「当社」といいます。）は、個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守すると共に、以下のプライバシーポリシー（以下「本プライバシーポリシー」といいます。）に従い、適切な取扱い及び保護に努めます。なお、本プライバシーポリシーにおいて別段の定めがない限り、本プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。
          </p>
          <p>
            <u>1.</u>
            <u>個人情報の定義</u>
          </p>
          <p>
            本プライバシーポリシーにおいて、個人情報とは、生存する個人に関する情報であって、次の各号のいずれかに該当するものをいいます。
          </p>
          <p>
            (1) &nbsp;&nbsp;&nbsp;
            当該情報に含まれる氏名、生年月日その他の記述等（文書、図画若しくは電磁的記録に記載され、若しくは記録され、又は音声、動作その他の方法を用いて表された一切の事項をいいます。）により特定の個人を識別することができるもの
            （他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）
          </p>
          <p>(2) &nbsp;&nbsp;&nbsp; 個人識別符号が含まれるもの</p>
          <p>
            <u>2.</u>
            <u>個人情報の利用目的</u>
          </p>
          <p>当社は、個人情報を以下の目的で利用いたします。</p>
          <p>
            (1)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスの提供のため
          </p>
          <p>
            (2)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスに関するご案内、お問い合せ等への対応のため
          </p>
          <p>
            (3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため
          </p>
          <p>
            (4)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスに関する規約等の変更などを通知するため
          </p>
          <p>
            (5)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスの改善、新サービスの開発等に役立てるため
          </p>
          <p>
            (6)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            雇用管理、社内手続のため（役職員の個人情報について）
          </p>
          <p>
            (7)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            株主管理、会社法その他法令上の手続対応のため（株主、新株予約権者等の個人情報について）
          </p>
          <p>
            (8)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            xpression camera、xpression avatar、xpression chat、DigiSelf、EmbodyMeその他の当社サービスに関連して、個人を識別できない形式に加工した統計データを作成するため
          </p>
          <p>
            (9)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            その他、上記利用目的に付随する目的のため
          </p>
          <p>
            <u>3.</u>
            <u>個人情報利用目的の変更</u>
          </p>
          <p>
            当社は、個人情報の利用目的を関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には個人情報の主体である個人（以下「本人」といいます。）に通知し又は公表します。
          </p>
          <p>
            <u>4.</u>
            <u>個人情報利用の制限</u>
          </p>
          <p>
            当社は、個人情報保護法その他の法令により許容される場合を除き、本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
          </p>
          <p>(1)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 法令に基づく場合</p>
          <p>
            (2)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
          </p>
          <p>
            (3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
          </p>
          <p>
            (4)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          </p>
          <p>
            <u>5.</u>
            <u>個人情報の適正な取得</u>
          </p>
          <p>
            5.1&nbsp;&nbsp;&nbsp;&nbsp;
            当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
          </p>
          <p>
            5.2&nbsp;&nbsp;&nbsp;&nbsp;
            xpression avatarでは、True Depth APIをリアルタイムでの表情トラッキングのために使用しています。True Depth APIから取得した情報を保持していません。
          </p>
          <p>
            <u>6.</u>
            <u>個人情報の安全管理</u>
          </p>
          <p>
            当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう個人情報管理責任者の設置、内部規律の整備、当社の従業員に対する監督、入退出管理、持ち込機器の制限、情報へのアクセス制限、不正アクセス防止措置等必要かつ適切な安全管理措置を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。安全管理措置に関するご質問につきましては、第12項の窓口にご連絡ください。
          </p>
          <p>
            <u>7.</u>
            <u>第三者提供</u>
          </p>
          <p>
            当社は個人情報保護法その他の法令により認められる場合を除き、個人情報の第三者提供を行いません。当社は、個人番号及び特定個人情報（個人番号をその内容に含む個人情報をいいます。）については、法令で認められた事務のためにのみ利用し、法令で認められる場合を除き、第三者に提供しません。
          </p>
          <p>
            <u>8.</u>
            <u>外国にある第三者提供</u>
          </p>
          <p>
            当社は、法令の定めに従い外国にある第三者へ個人情報の提供を行う場合は、情報提供等必要な措置を講じます。
          </p>
          <p>
            <u>9.</u>
            <u>個人情報の開示・訂正等の請求</u>
          </p>
          <p>
            当社は、保有する個人情報について、個人情報保護法に基づく利用目的の通知、開示（個人データの第三者への提供又は提供を受ける際の記録の開示を含みます。）、訂正・追加・削除、利用停止・消去及び第三者提供の停止の請求があった場合、請求された方が本人であることを確認した後、個人情報保護法に従って対応いたします。かかる請求を行う場合、第12項の窓口にご連絡下さい。
          </p>
          <p>
            <u>10.</u>
            <u>匿名加工情報の取扱い</u>
          </p>
          <p>
            当社は、法令に従い匿名加工情報及び仮名加工情報（個人情報保護法で定義する「匿名加工情報」及び「仮名加工情報」をいいます。）を取り扱います。
          </p>
          <p>
            <u>11.</u>
            <u>Cookie（クッキー）及びGoogleアナリティクスの利用</u>
          </p>
          <p>
            当社のサービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による当社のサービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、当社のサービスの一部の機能をご利用いただけなくなる場合があります。
          </p>
          <p>
            また、当社は、ウェブサイトの利用状況を把握するためにGoogle Analyticsを利用しております。データの収集、処理方法等のGoogle Analyticsの詳細については、下記のURLをご参照ください。
          </p>
          <p>https://marketingplatform.google.com/about/analytics/terms/jp/</p>
          <p>www.google.com/intl/ja/policies/privacy/</p>
          <p>www.google.com/intl/ja/policies/privacy/partners/</p>
          <p>
            <u>12.</u>
            <u>お問い合わせ</u>
          </p>
          <p>
            開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱いに関するお問い合わせは、下記の窓口までお願い致します。
          </p>
          <p>〒169-0075 &nbsp;&nbsp; 東京都新宿区高田馬場3-23-3 ORビルM2F</p>
          <p>株式会社EmbodyMe</p>
          <p>E-mail&nbsp;&nbsp;&nbsp;&nbsp; ：info@embodyme.com</p>
          <p>
            <u>13.</u>
            <u>ビジネスプランにおける個人データの取扱い</u>
          </p>
          <p>
            当社は、DigiSelfのビジネスプランにおいて本人が提供した個人データを、当社が提供する基盤モデルの学習には利用しません。
          </p>
          <p>
            <u>14.</u>
            <u>継続的改善</u>
          </p>
          <p>
            当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを変更することがあります。
          </p>
          <p>【2018年11月28日制定】</p>
          <p>【2026年3月30日改定】</p>
        </article>
      </section>
    </div>

    <Footer location={location} />
  </Layout>
)

export default PrivacyPolicyPage
